export default __webpack_public_path__ + "static/media/goshen100.a324f4ab.jpg";